// API URL configuration
export const API_URL = process.env.REACT_APP_API_URL || 'https://www.leavewise.cloud';

// Subscription plan configurations
export const SUBSCRIPTION_PLANS = {
  small: {
    name: 'Small',
    userLimit: 5,
    price: '£4.99'
  },
  medium: {
    name: 'Medium',
    userLimit: 12,
    price: '£9.99'
  },
  large: {
    name: 'Large',
    userLimit: 20,
    price: '£14.99'
  },
  enterprise: {
    name: 'Enterprise',
    userLimit: 100,
    price: '£49.99'
  }
};

// Other application constants
export const APP_NAME = 'LeaveWise';
export const COPYRIGHT_YEAR = new Date().getFullYear();
